
// src/actions/notifications.js

import api from './gamba-api'
import { emitAlertMessage, clearAlertMessage } from './alert-message'

export const FETCH_NOTIFICATIONS = "FETCH_NOTIFICATIONS"
export const FETCH_NOTIFICATIONS_REQUESTED = "FETCH_NOTIFICATIONS_REQUESTED"
export const FETCH_NOTIFICATIONS_COMPLETED = "FETCH_NOTIFICATIONS_COMPLETED"
export const FETCH_NOTIFICATIONS_FAILED = "FETCH_NOTIFICATIONS_FAILED"

export function fetchNotificationsRequested(group_id) {
  return {
    type: FETCH_NOTIFICATIONS_REQUESTED,
    group_id
  }
}

export function fetchNotifications(group_id, offset) {
  return function(dispatch) {
    dispatch(fetchNotificationsRequested(group_id))
    return api.get(`/notifications`, { group_id, offset })
        .then((results)=> {
          dispatch(fetchNotificationsCompleted(group_id, results, offset))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchNotificationsFailed(group_id, error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchNotificationsCompleted(group_id, results, offset) {
  return {
    type: FETCH_NOTIFICATIONS_COMPLETED,
    results, offset, group_id,
  }
}

export function fetchNotificationsFailed(group_id, error) {
  return {
    type: FETCH_NOTIFICATIONS_FAILED,
    error, group_id,
  }
}

export const FETCH_NOTIFICATIONS_UNREAD_COUNT = "FETCH_NOTIFICATIONS_UNREAD_COUNT"
export const FETCH_NOTIFICATIONS_UNREAD_COUNT_REQUESTED = "FETCH_NOTIFICATIONS_UNREAD_COUNT_REQUESTED"
export const FETCH_NOTIFICATIONS_UNREAD_COUNT_COMPLETED = "FETCH_NOTIFICATIONS_UNREAD_COUNT_COMPLETED"
export const FETCH_NOTIFICATIONS_UNREAD_COUNT_FAILED = "FETCH_NOTIFICATIONS_UNREAD_COUNT_FAILED"

export function fetchNotificationsUnreadCountRequested() {
  return {
    type: FETCH_NOTIFICATIONS_UNREAD_COUNT_REQUESTED
  }
}

export function fetchNotificationsUnreadCount(group_id) {
  return function(dispatch) {
    dispatch(fetchNotificationsUnreadCountRequested())
    return api.get(`/notifications/count`, { group_id })
        .then((results)=> {
          dispatch(fetchNotificationsUnreadCountCompleted(results, group_id))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchNotificationsUnreadCountFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchNotificationsUnreadCountCompleted(results, group_id) {
  return {
    type: FETCH_NOTIFICATIONS_UNREAD_COUNT_COMPLETED,
    results, group_id
  }
}

export function fetchNotificationsUnreadCountFailed(error) {
  return {
    type: FETCH_NOTIFICATIONS_UNREAD_COUNT_FAILED,
    error,
  }
}

export const LOAD_NOTIFICATION_UNREAD_COUNT = "LOAD_NOTIFICATION_UNREAD_COUNT"

export function loadNotificationUnreadCount(group_id, count) {
  return {
    type: LOAD_NOTIFICATION_UNREAD_COUNT, count, group_id,
  }
}

export const FLUSH_UNREAD_NOTIFICATIONS = "FLUSH_UNREAD_NOTIFICATIONS"
export const FLUSH_UNREAD_NOTIFICATIONS_REQUESTED = "FLUSH_UNREAD_NOTIFICATIONS_REQUESTED"
export const FLUSH_UNREAD_NOTIFICATIONS_COMPLETED = "FLUSH_UNREAD_NOTIFICATIONS_COMPLETED"
export const FLUSH_UNREAD_NOTIFICATIONS_FAILED = "FLUSH_UNREAD_NOTIFICATIONS_FAILED"

export function flushUnreadNotificationsRequested() {
  return {
    type: FLUSH_UNREAD_NOTIFICATIONS_REQUESTED
  }
}

export function flushUnreadNotifications(group_id) {
  return function(dispatch) {
    dispatch(flushUnreadNotificationsRequested())
    return api.get(`/notifications/flush`, { group_id })
        .then((results)=> {
          dispatch(flushUnreadNotificationsCompleted(results, group_id))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(flushUnreadNotificationsFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function flushUnreadNotificationsCompleted(results, group_id) {
  return {
    type: FLUSH_UNREAD_NOTIFICATIONS_COMPLETED,
    results, group_id,
  }
}

export function flushUnreadNotificationsFailed(error) {
  return {
    type: FLUSH_UNREAD_NOTIFICATIONS_FAILED,
    error,
  }
}

export const UPDATE_NOTIFICATION_STATUS = "UPDATE_NOTIFICATION_STATUS"
export const UPDATE_NOTIFICATION_STATUS_REQUESTED = "UPDATE_NOTIFICATION_STATUS_REQUESTED"
export const UPDATE_NOTIFICATION_STATUS_COMPLETED = "UPDATE_NOTIFICATION_STATUS_COMPLETED"
export const UPDATE_NOTIFICATION_STATUS_FAILED = "UPDATE_NOTIFICATION_STATUS_FAILED"

export function updateNotificationStatusRequested() {
  return {
    type: UPDATE_NOTIFICATION_STATUS_REQUESTED
  }
}

export function updateNotificationStatus(notification_id, opt = {}) {
  return function(dispatch) {
    dispatch(updateNotificationStatusRequested())
    return api.put(`/notifications/${notification_id}/status`, opt)
        .then((results)=> {
          dispatch(updateNotificationStatusCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(updateNotificationStatusFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function updateNotificationStatusCompleted(results) {
  return {
    type: UPDATE_NOTIFICATION_STATUS_COMPLETED,
    results,
  }
}

export function updateNotificationStatusFailed(error) {
  return {
    type: UPDATE_NOTIFICATION_STATUS_FAILED,
    error,
  }
}

export const CLEAR_NOTIFICATIONS = "CLEAR_NOTIFICATIONS"

export function clearNotifications() {
  return {
    type: CLEAR_NOTIFICATIONS
  }
}



// WEBPACK FOOTER //
// ./src/actions/notifications.js